module.exports = __webpack_public_path__ + "static/media/de.550ac30f.svg";